// import ConfirmationDialog from 'components/dialog/ConfirmationDialog';
// import useUnsavedChangesWarning from 'hooks/useUnsavedChangesWarning';
// import { memo, useCallback } from 'react';
// import { useDispatch } from 'react-redux';
// import { BlockerFunction, useBlocker } from 'react-router';
// import { RootState, useSelector } from 'store';
// import { setFormClean } from 'store/reducers/formslice';

// // To show this popup before navigtaion in some places like
// interface PageBlockerProps {
//   forceBlock?: boolean;
//   handleCacel?: () => void;
//   handleConfirm?: () => void;
// }

// const PageBlocker = ({ forceBlock, handleCacel, handleConfirm }: PageBlockerProps) => {
//   const dispatch = useDispatch();
//   const isFormDirty = useSelector((state: RootState) => state.formslice.isDirty);
//   useUnsavedChangesWarning(isFormDirty || Boolean(forceBlock));

//   let shouldBlock = useCallback<BlockerFunction>(
//     ({ currentLocation, nextLocation }) => (isFormDirty && currentLocation.pathname !== nextLocation.pathname) || Boolean(forceBlock),
//     [isFormDirty, forceBlock]
//   );
//   let blocker = useBlocker(shouldBlock);

//   const handleContinueToNextScreen = useCallback(() => {
//     dispatch(setFormClean());
//     if (blocker.proceed) {
//       blocker.proceed();
//     }
//     if (handleConfirm && forceBlock) {
//       if (blocker.reset) blocker.reset();
//       handleConfirm();
//     }
//   }, [blocker, dispatch, handleConfirm, forceBlock]);
//   const handleStayOnThePage = useCallback(() => {
//     if (blocker.reset) blocker.reset();
//     if (handleCacel && forceBlock) handleCacel();
//   }, [blocker, handleCacel, forceBlock]);

//   return (
//     <ConfirmationDialog
//       open={Boolean(forceBlock) || blocker.state === 'blocked'}
//       onClose={handleStayOnThePage}
//       onConfirm={handleContinueToNextScreen}
//       isLoading={false}
//       confirmationKey="navigateAway"
//       alertMessage="You have unsaved changes that will be lost, if you decide to leave this page."
//       message="Are you sure you want to leave this page?"
//       confirmButtonLabel="Leave this page"
//       cancelButtonLabel="Stay on this page"
//       type="unsavedChanges"
//       customMaxWidth="510px"
//     />
//   );
// };

// export default memo(PageBlocker);

import ConfirmationDialog from 'components/dialog/ConfirmationDialog';
import useUnsavedChangesWarning from 'hooks/useUnsavedChangesWarning';
import { memo, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BlockerFunction, useBlocker } from 'react-router';
import { RootState, useSelector } from 'store';
import { hidePageBlocker } from 'store/reducers/pageBlockerSlice';
import { setFormClean } from 'store/reducers/formslice';
// To show this popup before navigtaion in some places like

const PageBlocker = () => {
  const dispatch = useDispatch();
  const { forceBlock, blockerCallbacks } = useSelector((state: RootState) => state.pageBlockerSlice);
  const isFormDirty = useSelector((state: RootState) => state.formslice.isDirty);
  useUnsavedChangesWarning(isFormDirty || Boolean(forceBlock));

  // Inside PageBlocker component
  // 1️ Setup route blocker
  const shouldBlock = useCallback<BlockerFunction>(
    ({ currentLocation, nextLocation }) => {
      console.log('shouldBlock', { isFormDirty, forceBlock, currentLocation, nextLocation });
      if (!isFormDirty && !forceBlock) return false;
      return currentLocation.pathname !== nextLocation.pathname;
    },
    [isFormDirty, forceBlock]
  );

  const blocker = useBlocker(shouldBlock);
 
  console.log('blocker state', blocker.state);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      console.log('PageBlocker is active', { blocker, isFormDirty, forceBlock });
    }
  }, [blocker.state, isFormDirty, forceBlock]);
  
  useEffect(() => {
    // ensure the blocker is reset at unmount
    return () => {
      if (blocker.state === 'blocked') blocker.reset();
    };
  }, [blocker]);


  // 2️ When user confirms: continue to next screen
  const handleContinueToNextScreen = useCallback(() => {
    if (blocker?.proceed) blocker.proceed();

    dispatch(setFormClean());

    if (blockerCallbacks?.onConfirm && forceBlock) {
      blockerCallbacks.onConfirm();
    }

    dispatch(hidePageBlocker());
  }, [blocker, blockerCallbacks?.onConfirm, forceBlock, dispatch]);

  // 3️ When user cancels: stay on page
  const handleStayOnThePage = useCallback(() => {
    if (blocker?.reset) blocker.reset();
    if (blockerCallbacks?.onCancel && forceBlock) {
      blockerCallbacks.onCancel();
    }

    dispatch(hidePageBlocker());
  }, [blocker, blockerCallbacks?.onCancel, forceBlock, dispatch]);

  const shouldShowDialog = forceBlock || blocker.state === 'blocked';

  if (!shouldShowDialog) return null;

  return (
    <ConfirmationDialog
      open={shouldShowDialog}
      onClose={handleStayOnThePage}
      onConfirm={handleContinueToNextScreen}
      isLoading={false}
      confirmationKey="navigateAway"
      alertMessage="You have unsaved changes that will be lost, if you decide to leave this page."
      message={'Are you sure you want to leave this page?'}
      confirmButtonLabel={'Leave this page'}
      cancelButtonLabel={'Stay on this page'}
      type="unsavedChanges"
      customMaxWidth="510px"
    />
  );
};

export default memo(PageBlocker);
